import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import {
  Section,
  MediaQuery,
  EmailSignup,
  WorkFlow,
  CallToActionBanner,
  CrewImages,
  SelectedUseCase,
  AitoApiBlock,
  WhyAitoBlock,
  LogoCarousel
} from '..'
import * as styles from './styles'
import variables from '../../styles/variables'


const propTypes = {
  data: PropTypes.shape({
    allYaml: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({
          carouselHeader: PropTypes.string,
        }),
      })),
    })
  }).isRequired
}

export default function IndexContent({ data }) {
  return (
    <Section>
      <styles.Container>
        <styles.CarouselContainer>
          <styles.CarouselHeader>{data.carouselHeader}</styles.CarouselHeader>
          <LogoCarousel />
        </styles.CarouselContainer>

        <styles.SectionContainer>
          <styles.SectionHeader>{data.selectedUseCaseHeader}</styles.SectionHeader>
          <Section>
            <SelectedUseCase />
          </Section>
        </styles.SectionContainer>

        <WhyAitoBlock />
        <WorkFlow />
        <AitoApiBlock />
        <styles.CallToActionContainer>
          <Row>
            <Col sm={11} xs={12}>
              <CallToActionBanner
                smallHeader={data.indexBannerSmallHeader}
                header={data.indexBannerHeader}
                buttonTitle={data.indexBannerButton.text}
                linkText={data.indexBannerLink.text}
                buttonUrl={data.indexBannerButton.url}
                linkUrl={data.indexBannerLink.url}
                target="_blank"
              />
            </Col>
            <MediaQuery query={variables.media.md}>
              <Col sm={1}>
                <CrewImages />
              </Col>
            </MediaQuery>
          </Row>
        </styles.CallToActionContainer>
        <EmailSignup />
      </styles.Container>
    </Section>
  )
}

IndexContent.propTypes = propTypes
